<div class="position-relative parent">
  @if (header && recordsCount > 0) {
    <div class="multi-forms-header bg-white">
      <div class="container-fluid">
        <div class="row">
          <div class="row-icon fill-black d-flex align-items-center" aria-label="icon" [inlineSVG]="icon"></div>
          <div class="section-title"><span>{{header}} ({{recordsCount}}) {{ section === 'product' ||
          section === 'budget' ? workingdays : '' }}</span></div>
          <div ngbDropdown placement="bottom-left" [ngClass]="!isOpen ? 'ngbDropdown-translate' : 'ngbDropdown'" class="second-right-icon">
            @if (section === 'budget') {
              <div [ngClass]="isOpen ? 'div-translate' : 'div-not-translate'">
                <form autocomplete="off" >
                  <input class="search-input form-control"  type="text" name="quick-search-budget" id="quick-search-budget"
                    [placeholder]="'buttons.quickSearch' | translate"  [(ngModel)]="searchValueBudget"
                    (keydown)="isLoading=true; budgets=[]; this.search($event); ">
                  </form>
                  <!--    <div *ngIf="isOpen && isLoading && searchValueBudget.length > 0" class="ng-spinner-loader"></div>
                  <div ngbDropdownMenu aria-labelledby="quick-search" [ngClass]="searchValueBudget.length > 0 ? 'show' : ''"
                    class="scrollable-menu" role="menu" placement="bottom-left" style="width: max-content;">
                    <div class="section-name" *ngIf="searchValueBudget.length > 2 && !isLoading" style="cursor: default;">
                    </div>
                    <div *ngIf="budgets.length === 0 && searchValueBudget.length > 2 && !isLoading" class="no-data">
                      <div class="data-row">No Budgets Found</div>
                    </div>
                    <div ngbDropdownItem *ngFor="let res of budgets">
                      <div class="menu-button" (click)="redirect(res.identifier)">
                        <div class="data-row"
                          [innerHTML]="res.name | highlight: searchValueBudget">
                        </div>
                      </div>
                    </div>
                  </div>-->
                  <button class="btn closeSearch" (click)="closeSearchBudget()">
                    <div [inlineSVG]="'assets/ico/clear-button.svg'" class="icon icon-black clear-search-icon" alt="clear">
                    </div>
                  </button>
                </div>
              }
            </div>
            @if (section === 'budget' && !isOpen) {
              <div>
                <button class="btn openSearch" [ngClass]="isOpen ? 'button-translate' : 'button-not-translate'" >
                  <div class="second-right-icon row-icon fill-black d-flex align-items-right" aria-label="icon" [inlineSVG]="'assets/ico/search.svg'" alt="search icon" (click)="seacrhBudgetName()"
                    ngbTooltip="Budget Search" tooltipClass="animation-tooltip" placement="bottom"
                  container="body" triggers="hover"></div>
                </button>
              </div>
            }
            @if (rightIcon) {
              <div (click)="rightIconEvent.emit(true)"
                class="right-icon row-icon fill-black d-flex align-items-right" aria-label="icon"
              [inlineSVG]="rightIcon"></div>
            }
          </div>
        </div>
      </div>
    }

    @if (forms.controls.length > 0) {
      <div #toggle (mouseover)="toggleExpandedClass(true)" (mouseout)="toggleExpandedClass(false)"
        (click)="toggleAll()" class="toggle-icon fill-black mt-3"
        [ngClass]="allCollapsed ? 'toggle-shrinked' : 'toggle-expanded'" aria-label="toggle"
      [inlineSVG]="'assets/ico/expand-arrows-solid.svg'"></div>
    }
    @for (item of $any(forms).controls; track item; let i = $index) {
      <app-collapsable-row [imgSrc]="showRowIcon ? icon : null" [title]=item.name [isCollapsed]='item.isCollapsed'
        [isClosable]="!item.editForm" [section]="section" [index]="i"
        (collapseEvent)="toggleElement(item.value.identifier, false)" (click)="setToggle()"
        [id]="item.value.identifier" [isEdit]="item.editForm">
        <apc-action-card [headerCursorPointer]="true" [showIcon]="showHeaderIcon">
          @if (icon) {
            <img icon [src]="icon" alt="user" />
          }
          <span title [innerHTML]="item.name"></span>
          <apc-multi-action-buttons (editEvent)="onEdit(item, $event)" [edit]="item.editForm"
            (saveEvent)="saveForm(item)"
            (refreshTitleEvent)="addTitleToCollapsable()"
            (createBudgetEvent)="item.controls.addAllAvailableProducts.setValue(true); saveForm(item);"
            (cancelEvent)="cancelForm(item)" (cloneEvent)="cloneForm(item)" [pertinence]="pertinence"
            [section]="section" [subsection]="subsection" (fillFullTimeEvent)="fillFullTime(item)" buttons
            [personaSubsectionIdentifier]="item.value.identifier" [personaIdentifier]="user_id"
            (deleteEvent)="delete(item.value.identifier)" [form]="item" [forms]="forms" (newProductEvent)="newProduct(item)"
            [deleteText]="'Are you sure to delete this item?'"
            (newProjectEvent)="newProject(item.value.identifier, item.value.project)"
            (newBudgetFill)="newBudgetFill(item.value.identifier)"
            [hideClone]="section === 'product' || section === 'budget'"
            (deleteBudgetEvent)="deleteBudgetEvent($event)">
          </apc-multi-action-buttons>
          <div content class="fullwidth" [class.editForm]="item.editForm">
            <form [formGroup]="item">
              <ng-container *ngTemplateOutlet="formTemplate; context: { $implicit: item  }">
              </ng-container>
            </form>
          </div>
        </apc-action-card>
      </app-collapsable-row>
    }
    @if (section === 'budget' && forms.controls.length < recordQuery) {
      <ngb-pagination [collectionSize]="recordQuery"  [(page)]="page" [boundaryLinks]="true" [maxSize]=1 [ellipses]="false" (pageChange)="pageChange()" ></ngb-pagination>
    }
    <br/>
  </div>